import React from "react";
import Context from "../../../Context";
import Blocker from "../Blocker";
import BsModal from "../BsModal";
import DefaultNotFound from "../DefaultNotFound";
import Modal from "../Modal";
import Searchbox from "../Searchbox";

const defaultReclimit = 10;

export default class OutsidePickModal extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      init: false,
      pending: false,
      showMoreButton: false,
      items: [],
      queryParams: {
        search: [],
        reclimit: defaultReclimit,
        recoffset: 0,
      },
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.source !== this.props.source) {
      this.init();
      return;
    }
    if (!prevProps.show && this.props.show && !this.state.init) {
      this.init();
      return;
    }
  }

  init = () => {
    let search = [];

    if (this.props.source) {
      search.push({
        field: "source",
        value: this.props.source,
      });
    }
    if (this.state.searchText) {
      search.push({
        field: "name",
        compare: "IKE",
        value: `%${this.state.searchText}%`,
      });
    }

    this.setState(
      {
        init: true,
        items: [],
        showMoreButton: false,
        queryParams: {
          search,
          reclimit: this.props.reclimit || defaultReclimit,
          recoffset: 0,
        },
      },
      () => this.load()
    );
  };

  load = async () => {
    let { queryParams, items } = this.state;
    this.setState({ pending: true });

    let fetchItems = await this.context.api.qa("/outside/list", queryParams);
    let showMoreButton = fetchItems.length >= queryParams.reclimit;
    items = items.concat(fetchItems);

    this.setState({
      pending: false,
      items,
      showMoreButton,
      queryParams: {
        ...queryParams,
        recoffset: queryParams.recoffset + queryParams.reclimit,
      },
    });
  };

  onPick = (item) => {
    this.props.onPick(item);
    this.props.onClose();
  };

  onSearch = (v) => {
    this.setState({ searchText: v }, () => this.init());
  };

  render() {
    const { pending, items, showMoreButton } = this.state;
    const ModalComponent = this.props.keepModal ? Modal : BsModal;

    return (
      <ModalComponent
        center
        show={this.props.show}
        onClose={this.props.onClose}
      >
        <div className="mb-5">
          <Searchbox onSearch={this.onSearch} />
        </div>

        <Blocker mh hAutho spinnerFixed on={pending}>
          {!items.length && !pending && <DefaultNotFound />}

          {items.map((item) => {
            return (
              <div
                key={item?.id}
                className="py-4 px-2 border-bottom text-dark bg-hover-light"
                onClick={() => this.onPick(item)}
              >
                <div>{item?.name}</div>
                <div className="small text-muted font-italic ">
                  {item?.category}
                </div>
                <div>
                  {item?.class && (
                    <span className="small text-dark-75 mr-2">
                      {item?.class}
                    </span>
                  )}
                  {item?.code && (
                    <span className="small text-dark-50  mr-2">
                      {item?.code}
                    </span>
                  )}
                  {item?.identity && (
                    <span className="small text-muted mr-2 ">
                      {item?.identity}
                    </span>
                  )}
                </div>
              </div>
            );
          })}

          {showMoreButton && (
            <div className="text-center mt-5">
              <input
                type="button"
                className="btn btn-primary"
                value="Показать еще..."
                onClick={this.load}
              />
            </div>
          )}
        </Blocker>
      </ModalComponent>
    );
  }
}
